(function () {
    // === State ===
    var overlay = null;
    var input = null;
    var resultsList = null;
    var emptyMsg = null;
    var activeIndex = -1;
    var items = [];
    var previousFocus = null;
    var postIndex = null;

    // === Icons (inline SVG strings) ===
    var icons = {
        arrow: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',
        sun: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>',
        top: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>',
        share: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>',
        link: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>',
        post: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>'
    };

    // === Build navigation commands from sidebar links ===
    function getNavCommands() {
        var cmds = [];
        var selectors = ['.gh-sidebar-nav a', '.gh-sidebar-secondary a', '.gh-sidebar-legal a'];
        selectors.forEach(function (sel) {
            var links = document.querySelectorAll(sel);
            links.forEach(function (a) {
                var label = a.textContent.trim();
                if (label) {
                    cmds.push({ label: label, url: a.href, icon: icons.arrow, category: 'nav' });
                }
            });
        });
        return cmds;
    }

    // === Action commands ===
    function getActionCommands() {
        return [
            { label: 'Toggle theme', icon: icons.sun, category: 'action', action: function () {
                if (window.__toggleTheme) window.__toggleTheme();
            }},
            { label: 'Scroll to top', icon: icons.top, category: 'action', action: function () {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }},
            { label: 'Share this page', icon: icons.share, category: 'action', action: function () {
                if (navigator.share) {
                    navigator.share({ title: document.title, url: location.href });
                } else {
                    navigator.clipboard.writeText(location.href);
                }
            }},
            { label: 'Copy URL', icon: icons.link, category: 'action', action: function (li) {
                navigator.clipboard.writeText(location.href).then(function () {
                    var span = li.querySelector('.cmd-palette-result-label');
                    if (span) {
                        var orig = span.textContent;
                        span.textContent = 'URL copied!';
                        setTimeout(function () { span.textContent = orig; }, 1200);
                    }
                });
            }}
        ];
    }

    // === Load post index (lazy, once) ===
    function getPostIndex() {
        if (postIndex !== null) return postIndex;
        postIndex = [];
        var spans = document.querySelectorAll('#palette-posts span');
        spans.forEach(function (el) {
            var title = el.getAttribute('data-title');
            var url = el.getAttribute('data-url');
            if (title && url) {
                postIndex.push({
                    label: title,
                    url: url,
                    tag: el.getAttribute('data-tag') || '',
                    icon: icons.post,
                    category: 'post'
                });
            }
        });
        return postIndex;
    }

    // === Fuzzy match ===
    function fuzzyMatch(query, text) {
        var q = query.toLowerCase();
        var t = text.toLowerCase();
        var qi = 0;
        var score = 0;
        var consecutive = 0;
        var indices = [];

        for (var ti = 0; ti < t.length && qi < q.length; ti++) {
            if (t[ti] === q[qi]) {
                indices.push(ti);
                consecutive++;
                score += consecutive + (ti === 0 ? 2 : 0);
                qi++;
            } else {
                consecutive = 0;
            }
        }

        if (qi < q.length) return null;
        return { score: score, indices: indices };
    }

    // === Highlight matched characters ===
    function highlightMatch(text, indices) {
        if (!indices || !indices.length) return escapeHtml(text);
        var result = '';
        var set = {};
        indices.forEach(function (i) { set[i] = true; });
        for (var i = 0; i < text.length; i++) {
            if (set[i]) {
                result += '<mark>' + escapeHtml(text[i]) + '</mark>';
            } else {
                result += escapeHtml(text[i]);
            }
        }
        return result;
    }

    function escapeHtml(str) {
        return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    // === Filter and render ===
    function update(query) {
        query = (query || '').trim();
        var navCmds = getNavCommands();
        var actionCmds = getActionCommands();
        var postCmds = query.length >= 2 ? getPostIndex() : [];

        var results = [];

        // Filter navigation
        var navMatches = filterCommands(navCmds, query);
        if (navMatches.length) {
            results.push({ type: 'category', label: 'Navigation' });
            results = results.concat(navMatches);
        }

        // Filter actions
        var actionMatches = filterCommands(actionCmds, query);
        if (actionMatches.length) {
            results.push({ type: 'category', label: 'Actions' });
            results = results.concat(actionMatches);
        }

        // Filter posts
        if (postCmds.length) {
            var postMatches = filterCommands(postCmds, query).slice(0, 8);
            if (postMatches.length) {
                results.push({ type: 'category', label: 'Posts' });
                results = results.concat(postMatches);
            }
        }

        render(results);
    }

    function filterCommands(cmds, query) {
        if (!query) return cmds.map(function (c) { return { cmd: c, html: escapeHtml(c.label), score: 0 }; });

        var matches = [];
        cmds.forEach(function (cmd) {
            var m = fuzzyMatch(query, cmd.label);
            if (m) {
                matches.push({ cmd: cmd, html: highlightMatch(cmd.label, m.indices), score: m.score });
            }
        });
        matches.sort(function (a, b) { return b.score - a.score; });
        return matches;
    }

    function render(results) {
        items = [];
        resultsList.innerHTML = '';
        activeIndex = -1;

        if (!results.length) {
            emptyMsg.hidden = false;
            return;
        }
        emptyMsg.hidden = true;

        results.forEach(function (r) {
            if (r.type === 'category') {
                var li = document.createElement('li');
                li.className = 'cmd-palette-category';
                li.textContent = r.label;
                li.setAttribute('role', 'presentation');
                resultsList.appendChild(li);
                return;
            }

            var li = document.createElement('li');
            li.className = 'cmd-palette-result';
            li.setAttribute('role', 'option');
            li.setAttribute('aria-selected', 'false');
            li.innerHTML =
                '<span class="cmd-palette-result-icon">' + r.cmd.icon + '</span>' +
                '<span class="cmd-palette-result-label">' + r.html + '</span>' +
                (r.cmd.tag ? '<span class="cmd-palette-result-tag">' + escapeHtml(r.cmd.tag) + '</span>' : '');

            li._cmd = r.cmd;
            li.addEventListener('click', function () { execute(li); });
            li.addEventListener('mouseenter', function () { setActive(items.indexOf(li)); });

            resultsList.appendChild(li);
            items.push(li);
        });

        if (items.length) setActive(0);
    }

    function setActive(index) {
        if (index < 0 || index >= items.length) return;
        if (activeIndex >= 0 && activeIndex < items.length) {
            items[activeIndex].setAttribute('aria-selected', 'false');
        }
        activeIndex = index;
        items[activeIndex].setAttribute('aria-selected', 'true');
        items[activeIndex].scrollIntoView({ block: 'nearest' });
        input.setAttribute('aria-activedescendant', '');
    }

    function execute(li) {
        var cmd = li._cmd;
        if (cmd.url) {
            close();
            window.location.href = cmd.url;
        } else if (cmd.action) {
            cmd.action(li);
            if (cmd.label !== 'Copy URL') close();
        }
    }

    // === Open / Close ===
    function open() {
        if (!overlay) {
            overlay = document.getElementById('cmd-palette');
            input = overlay.querySelector('.cmd-palette-input');
            resultsList = overlay.querySelector('.cmd-palette-results');
            emptyMsg = overlay.querySelector('.cmd-palette-empty');

            input.addEventListener('input', function () { update(input.value); });
        }

        previousFocus = document.activeElement;
        overlay.hidden = false;
        overlay.classList.remove('closing');
        input.value = '';
        update('');
        input.focus();
        document.body.style.overflow = 'hidden';
    }

    function close() {
        if (!overlay || overlay.hidden) return;

        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reducedMotion) {
            finishClose();
        } else {
            overlay.classList.add('closing');
            overlay.addEventListener('animationend', function handler() {
                overlay.removeEventListener('animationend', handler);
                finishClose();
            });
        }
    }

    function finishClose() {
        overlay.hidden = true;
        overlay.classList.remove('closing');
        document.body.style.overflow = '';
        if (previousFocus) previousFocus.focus();
    }

    function isOpen() {
        return overlay && !overlay.hidden;
    }

    // === Keyboard handling ===
    document.addEventListener('keydown', function (e) {
        // Cmd+K / Ctrl+K toggle
        if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
            e.preventDefault();
            if (isOpen()) { close(); } else { open(); }
            return;
        }

        // "/" to open (when not in an input)
        if (e.key === '/' && !isOpen()) {
            var tag = document.activeElement.tagName;
            if (tag !== 'INPUT' && tag !== 'TEXTAREA' && !document.activeElement.isContentEditable) {
                e.preventDefault();
                open();
                return;
            }
        }

        if (!isOpen()) return;

        switch (e.key) {
            case 'Escape':
                e.preventDefault();
                close();
                break;
            case 'ArrowDown':
                e.preventDefault();
                if (items.length) setActive((activeIndex + 1) % items.length);
                break;
            case 'ArrowUp':
                e.preventDefault();
                if (items.length) setActive((activeIndex - 1 + items.length) % items.length);
                break;
            case 'Enter':
                e.preventDefault();
                if (activeIndex >= 0 && activeIndex < items.length) {
                    execute(items[activeIndex]);
                }
                break;
            case 'Tab':
                e.preventDefault();
                break;
        }
    });

    // === Backdrop click to close ===
    document.addEventListener('click', function (e) {
        if (isOpen() && e.target.classList.contains('cmd-palette-backdrop')) {
            close();
        }
    });

    // === Trigger buttons ===
    document.addEventListener('DOMContentLoaded', function () {
        var triggers = document.querySelectorAll('.cmd-palette-trigger');
        triggers.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                open();
            });
        });

        // === Random article ===
        var randomLink = document.getElementById('random-post');
        if (randomLink) {
            randomLink.addEventListener('click', function (e) {
                e.preventDefault();
                var posts = getPostIndex();
                if (posts.length) {
                    var pick = posts[Math.floor(Math.random() * posts.length)];
                    window.location.href = pick.url;
                }
            });
        }
    });
})();
